/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MapObject } from './MapObject';
import {
    MapObjectFromJSON,
    MapObjectFromJSONTyped,
    MapObjectToJSON,
    MapObjectToJSONTyped,
} from './MapObject';

/**
 * 
 * @export
 * @interface GoodsMarketBarcodeVo
 */
export interface GoodsMarketBarcodeVo {
    /**
     * 订单商品条码记录ID。
     * 订单商品条码记录ID，由后端生成
     * @type {number}
     * @memberof GoodsMarketBarcodeVo
     */
    id?: number;
    /**
     * 来源SKU条码ID，仅用于追溯。
     * 来源SKU条码ID，由后端复制SKU条码时记录
     * @type {number}
     * @memberof GoodsMarketBarcodeVo
     */
    sourceMarketBarcodeId?: number;
    /**
     * 来源订单商品平台条码ID。
     * 来源订单商品平台条码ID，由后端合包、拆分或复制时记录
     * @type {number}
     * @memberof GoodsMarketBarcodeVo
     */
    sourceGoodsMarketBarcodeId?: number;
    /**
     * 平台稳定编码，例如 COUPANG。
     * 平台稳定编码，由后端根据平台ID获取
     * @type {string}
     * @memberof GoodsMarketBarcodeVo
     */
    businessPlatformCode?: string;
    /**
     * 第三方电商平台名称。
     * 第三方电商平台名称，由后端根据平台ID获取
     * @type {string}
     * @memberof GoodsMarketBarcodeVo
     */
    businessPlatformName?: string;
    /**
     * 同一商品内的显示顺序。
     * 同一商品内的显示顺序，由后端根据数组顺序生成
     * @type {number}
     * @memberof GoodsMarketBarcodeVo
     */
    sort?: number;
    /**
     * 数据来源：1旧字段迁移，2 SKU复制，3人工录入，4平台API同步，5合包复制。
     * 数据来源，由后端按业务场景生成
     * @type {number}
     * @memberof GoodsMarketBarcodeVo
     */
    sourceType?: number;
    /**
     * 
     * @type {MapObject}
     * @memberof GoodsMarketBarcodeVo
     */
    extensionData?: MapObject;
    /**
     * 第三方电商平台ID。
     * 第三方电商平台ID
     * @type {number}
     * @memberof GoodsMarketBarcodeVo
     */
    businessPlatformId?: number;
    /**
     * 平台条码。
     * 平台条码
     * @type {string}
     * @memberof GoodsMarketBarcodeVo
     */
    marketBarcode?: string;
    /**
     * 平台商品名称。
     * 平台商品名称
     * @type {string}
     * @memberof GoodsMarketBarcodeVo
     */
    marketProductName?: string;
    /**
     * 平台选项名称。
     * 平台选项名称
     * @type {string}
     * @memberof GoodsMarketBarcodeVo
     */
    marketOptionName?: string;
    /**
     * 平台选项ID。
     * 平台选项ID
     * @type {string}
     * @memberof GoodsMarketBarcodeVo
     */
    marketOptionId?: string;
    /**
     * 是否为当前商品主显示条码：0否，1是。
     * 是否为主显示条码：0否，1是
     * @type {number}
     * @memberof GoodsMarketBarcodeVo
     */
    isPrimary?: number;
}

/**
 * Check if a given object implements the GoodsMarketBarcodeVo interface.
 */
export function instanceOfGoodsMarketBarcodeVo(value: object): value is GoodsMarketBarcodeVo {
    return true;
}

export function GoodsMarketBarcodeVoFromJSON(json: any): GoodsMarketBarcodeVo {
    return GoodsMarketBarcodeVoFromJSONTyped(json, false);
}

export function GoodsMarketBarcodeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsMarketBarcodeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sourceMarketBarcodeId': json['sourceMarketBarcodeId'] == null ? undefined : json['sourceMarketBarcodeId'],
        'sourceGoodsMarketBarcodeId': json['sourceGoodsMarketBarcodeId'] == null ? undefined : json['sourceGoodsMarketBarcodeId'],
        'businessPlatformCode': json['businessPlatformCode'] == null ? undefined : json['businessPlatformCode'],
        'businessPlatformName': json['businessPlatformName'] == null ? undefined : json['businessPlatformName'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'extensionData': json['extensionData'] == null ? undefined : MapObjectFromJSON(json['extensionData']),
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProductName': json['marketProductName'] == null ? undefined : json['marketProductName'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
    };
}

export function GoodsMarketBarcodeVoToJSON(json: any): GoodsMarketBarcodeVo {
    return GoodsMarketBarcodeVoToJSONTyped(json, false);
}

export function GoodsMarketBarcodeVoToJSONTyped(value?: GoodsMarketBarcodeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sourceMarketBarcodeId': value['sourceMarketBarcodeId'],
        'sourceGoodsMarketBarcodeId': value['sourceGoodsMarketBarcodeId'],
        'businessPlatformCode': value['businessPlatformCode'],
        'businessPlatformName': value['businessPlatformName'],
        'sort': value['sort'],
        'sourceType': value['sourceType'],
        'extensionData': MapObjectToJSON(value['extensionData']),
        'businessPlatformId': value['businessPlatformId'],
        'marketBarcode': value['marketBarcode'],
        'marketProductName': value['marketProductName'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'isPrimary': value['isPrimary'],
    };
}

